import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import RichTextBoxViewModelType from '@/ViewModels/Controls/RichTextBoxViewModel';

export default class RichTextBox extends Control {

    private jQueryControl: JQuery;

    public constructor(private viewModel: RichTextBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div></div>');

        this.applyBindings(this.jQueryControl, {
            cfrichtexteditor: {
                tools: this.viewModel.tools,

                messages: this.viewModel.messages,

                value: this.viewModel.value,

                language: this.viewModel.language,

                readonly: this.defineComputed(() => {
                    let value = this.viewModel.isEnabled();
                    return !value;
                }),

                widget: this.widget,

                maxLength: this.viewModel.maxLength,

                onAfterInit: this.viewModel.onAfterInit
            },

            focus: this.viewModel.isFocusable
        });

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'richtextbox',
            tooltip: this.viewModel.tooltip,
            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            isValid: this.viewModel.isValid,

            invalid: this.viewModel.invalidationText,

            parentLocator: this.viewModel.parentLocator,

            locator: this.viewModel.locator,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    if (this.viewModel.windowCreated === true && this.viewModel.window.isOpen() === true) {
                        styles.push('maximized');
                    }

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        }); 
    }
}

ComponentManager.setControl('RichTextBox', RichTextBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');